import React, { useState, useEffect } from 'react';
import LogoRow from '../../components/LogoRow';
import ProgressionRow from '../../components/ProgressionRow';
import { PersonalDataPage, ForniturePage, ConsentPageI18n } from '../../i18n';
import FormSectionTitle from '../../components/FormSectionTitle';
import { GrayDiv, SectionTitle, SectionSubtitle, InputBooleanWrapper, MarketingTitle, InputsBooleanWrapperMarketing, InputBooleanWrapperMarketing, MarketingContainer, SectionTitleTopMargin, InputBooleanWrapperMarketingRightMargin, AccordionContainer, InfoIconContainer, TextConditions, ReadMore } from './style';
import { InputBoolean } from '../../components/InputBoolean';
import { CONSENT_FORM_FIELD_NAMES } from '../../reducers/consentForm';
import { THEME_COLORS, MEDIA_QUERIES } from '../../styles/theme';
import OfferBox from '../../components/OfferBox';
import { Accordion } from '../../components/Accordion';
import { BottomsheetTriggerTitle, BottomSheetHeaderText, BottomsheetTriggerContainer, BottomsheetTriggerSubTitle } from '../../components/BottomSheet/style';
import { BottomSheet } from '../../components/BottomSheet';
import { ENV_VARIABLES} from "../../envVariables";
import { Offer } from '../../components/Offer';
import { SubmitButton } from '../../components/Buttons';
import { ROUTES } from '../../utils/constants';
import { InfoIcon } from '../../components/InfoIcon';
import { InfoPopup } from './InfoPopup';
import { ChatCallContainer } from '../../components/ChatCallContainer';
import { FreeMarketText, VessatorieText, AcceptContractText, FastSwitchCompleteText } from './ConsentsComponents';
import { adfSendEvent } from '../../tracking/adfSendEvent';
import { setTrackerScript } from '../../tracking/setTracker';
import { getTrackingInfoOffer } from '../../tracking/getTrackingInfoOffer';
import {DataLayerContainerConsent} from "../../components/DataLayer";

export const ConsentPage = (props) => {
    const { offer } = props;
    const [isInfoPopupOpen, setIsInfoPopupOpen] = useState(false);
    const [popupContent, setPopupContent] = useState({ title: '', content: '' });
    const ProductAklamioArray = ENV_VARIABLES.ProductAklamioArray
    let ChatVisible = true
    if (offer.name.includes('VIVIpartner') || ProductAklamioArray.includes(offer.offerId))
    {
        ChatVisible = false
    }
    useEffect(() => {
        props.onChangeField(
            CONSENT_FORM_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10)
        );
    }, []);
    
    useEffect(() => {
        if (offer.name) {
            setTrackerScript({ ...getTrackingInfoOffer(offer), trackName: 'vivigas|x|funnel|consensi' });
        }
    }, [offer]);

    return (
        <React.Fragment>
            <DataLayerContainerConsent {...props} />
            <InfoPopup
                isOpen={isInfoPopupOpen}
                closePopup={() => setIsInfoPopupOpen(false)}
                content={popupContent}
            />
            <div className="container" style={{ marginBottom: '200px' }}>
                <ChatCallContainer 
                    trackerChat={() => adfSendEvent('vivigas|x|funnel|consensi|click_chat')()}
                    trackerCallMeClick={() => adfSendEvent("vivigas|x|funnel|consensi|click_ti_chiamiamo_noi")()}
                    callMeSubmitStartTrackName='vivigas|x|funnel|consensi|click_conferma'
                    callMeSubmitSuccessTrackName="vivigas|x|funnel|consensi|thankyou_richiamami"
                    isCallMeVisible={ChatVisible}
                />
                <LogoRow />
                <ProgressionRow backpath={ROUTES.paymentRecap} step={3} />
                <div className="row">
                    <div className="col col-xl-8">
                        <FormSectionTitle
                            title={PersonalDataPage.formTitle}
                            subtitle={PersonalDataPage.formSubtitle}
                            backpath={ROUTES.personalData}
                        />

                        <FormSectionTitle
                            title={ForniturePage.formTitle}
                            subtitle={ForniturePage.formSubtitle}
                            backpath={ROUTES.supply}
                        />

                        <FormSectionTitle
                            title={"Recapito e pagamento"}
                            subtitle={""}
                            backpath={ROUTES.paymentRecap}
                        />

                        <FormSectionTitle
                            title={"Consensi"}
                            subtitle={"Hai quasi finito! Prima di concludere leggi le condizioni contrattuali e l'Informativa Privacy ed esprimi il consenso al trattamento dati."}
                            isActive={true}

                        />

                        <GrayDiv>
                            <InfoIconContainer>
                                <InfoIcon onClick={() => {
                                    setPopupContent({ title: 'Passaggio rapido', content: <FastSwitchCompleteText /> });
                                    setIsInfoPopupOpen(true);
                                }} />
                            </InfoIconContainer>

                            <SectionTitle>Richiesta di passaggio rapido</SectionTitle>
                            <SectionSubtitle>Se scegli il passaggio rapido, puoi anticipare l'esecuzione del tuo contratto rispetto ai tempi standard previsti (per maggiori dettagli leggi la nota informativa)</SectionSubtitle>
                            
                            <div>
                                <InputBooleanWrapper>
                                    <InputBoolean
                                        label={`Si scelgo il passaggio rapido (la procedura di attivazione partirà da oggi)`}
                                        type="radio"
                                        name="passaggioRapido"
                                        isChecked={props.form[CONSENT_FORM_FIELD_NAMES.isFastSwitch]}
                                        onChange={() => props.onChangeField(CONSENT_FORM_FIELD_NAMES.isFastSwitch, true)}
                                    />
                                </InputBooleanWrapper>
                                <InputBooleanWrapper>
                                    <InputBoolean
                                        label="No, preferisco i tempi standard (la procedura di attivazione partirà fra 14 giorni)"
                                        type="radio"
                                        name="passaggioRapido"
                                        isChecked={!props.form[CONSENT_FORM_FIELD_NAMES.isFastSwitch]}
                                        onChange={() => props.onChangeField(CONSENT_FORM_FIELD_NAMES.isFastSwitch, false)}
                                    />
                                </InputBooleanWrapper>
                            </div>
                            {/* {isFastSwitchConditionOpen ?
                                <React.Fragment>
                                    <TextConditions>{ConsentPageI18n.fastSwitchConditionsShort}</TextConditions>
                                    <TextConditions>{ConsentPageI18n.fastSwitchConditions}</TextConditions>
                                    <ReadMore onClick={() => setIsFastSwitchConditionOpen(false)}> Leggi di meno</ReadMore>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <TextConditions>
                                        {ConsentPageI18n.fastSwitchConditionsShort} 
                                    </TextConditions>
                                    <ReadMore onClick={() => setIsFastSwitchConditionOpen(true)}>Leggi di più</ReadMore>
                                </React.Fragment>
                            } */}
                        </GrayDiv>

                        <GrayDiv>
                            <InfoIconContainer>
                                <InfoIcon onClick={() => {
                                    setPopupContent({ title: 'Accettazione del contratto', content: <AcceptContractText /> });
                                    setIsInfoPopupOpen(true);
                                }} />
                            </InfoIconContainer>

                            <SectionTitle>Accettazione del contratto</SectionTitle>
                            <InputBooleanWrapper>
                                <InputBoolean
                                    label="ACCETTO TUTTO"
                                    type="checkbox"
                                    isChecked={props.form[CONSENT_FORM_FIELD_NAMES.acceptAll]}
                                    onChange={() => props.onChangeField(
                                        CONSENT_FORM_FIELD_NAMES.acceptAll,
                                        !props.form[CONSENT_FORM_FIELD_NAMES.acceptAll]
                                    )}
                                />
                            </InputBooleanWrapper>

                            <div style={{ marginTop: '40px' }}>
                                <InputBooleanWrapper>
                                    <InputBoolean
                                        label="Ho letto con attenzione la documentazione allegata"
                                        type="checkbox"
                                        isChecked={props.form[CONSENT_FORM_FIELD_NAMES.acceptContract]}
                                        onChange={() => {
                                            props.onChangeField(
                                                CONSENT_FORM_FIELD_NAMES.acceptContract,
                                                !props.form[CONSENT_FORM_FIELD_NAMES.acceptContract]
                                            );
                                            props.onChangeField(
                                                CONSENT_FORM_FIELD_NAMES.acceptContractError,
                                                ''
                                            );
                                        }}
                                        errorText={props.form[CONSENT_FORM_FIELD_NAMES.acceptContractError]}
                                    />
                                </InputBooleanWrapper>
                                <InputBooleanWrapper>
                                    <InputBoolean
                                        label="Ho preso visione delle note legali e le informazioni precontrattuali del Codice Consumo"
                                        type="checkbox"
                                        isChecked={props.form[CONSENT_FORM_FIELD_NAMES.acceptLegal]}
                                        onChange={() => {
                                            props.onChangeField(
                                                CONSENT_FORM_FIELD_NAMES.acceptLegal,
                                                !props.form[CONSENT_FORM_FIELD_NAMES.acceptLegal]
                                            )
                                            props.onChangeField(
                                                CONSENT_FORM_FIELD_NAMES.acceptLegalError,
                                                ''
                                            );
                                        }}
                                        errorText={props.form[CONSENT_FORM_FIELD_NAMES.acceptLegalError]}
                                    />
                                </InputBooleanWrapper>
                            </div>

                            <SectionTitleTopMargin>Recesso dall'attuale fornitore</SectionTitleTopMargin>
                            <InputBooleanWrapper>
                                <InputBoolean
                                    label="Con l'accettazione del nuovo contratto di fornitura, conferisco mandato a VIVIgas per formalizzare il recesso dall'attuale fornitore"
                                    type="checkbox"
                                    isChecked={props.form[CONSENT_FORM_FIELD_NAMES.acceptSwitch]}
                                    onChange={() => {
                                        props.onChangeField(
                                            CONSENT_FORM_FIELD_NAMES.acceptSwitch,
                                            !props.form[CONSENT_FORM_FIELD_NAMES.acceptSwitch]
                                        )

                                        props.onChangeField(
                                            CONSENT_FORM_FIELD_NAMES.acceptSwitchError,
                                            ''
                                        )
                                    }}
                                    errorText={props.form[CONSENT_FORM_FIELD_NAMES.acceptSwitchError]}
                                />
                            </InputBooleanWrapper>

                            <SectionTitleTopMargin>Informativa sulla privacy</SectionTitleTopMargin>
                            <InputBooleanWrapper>
                                <InputBoolean
                                    label="Confermo di aver letto l'informativa sulla privacy"
                                    type="checkbox"
                                    isChecked={props.form[CONSENT_FORM_FIELD_NAMES.acceptPrivacy]}
                                    onChange={() => {
                                        props.onChangeField(
                                            CONSENT_FORM_FIELD_NAMES.acceptPrivacy,
                                            !props.form[CONSENT_FORM_FIELD_NAMES.acceptPrivacy]
                                        )
                                        props.onChangeField(
                                            CONSENT_FORM_FIELD_NAMES.acceptPrivacyError,
                                            ''
                                        );
                                    }}
                                    errorText={props.form[CONSENT_FORM_FIELD_NAMES.acceptPrivacyError]}
                                />
                            </InputBooleanWrapper>
                        </GrayDiv>

                        <GrayDiv>
                            <InfoIconContainer>
                                <InfoIcon onClick={() => {
                                    setPopupContent({ title: 'Clausole vessatorie', content: <React.Fragment><VessatorieText /></React.Fragment> });
                                    setIsInfoPopupOpen(true);
                                }} />
                            </InfoIconContainer>

                            <SectionTitle>{ConsentPageI18n.acceptVessatorieTitle}</SectionTitle>
                            <InputBooleanWrapper>
                                <InputBoolean
                                    label="Accetto"
                                    type="checkbox"
                                    isChecked={props.form[CONSENT_FORM_FIELD_NAMES.clausoleVessatorie]}
                                    onChange={() => {
                                        props.onChangeField(
                                            CONSENT_FORM_FIELD_NAMES.clausoleVessatorie,
                                            !props.form[CONSENT_FORM_FIELD_NAMES.clausoleVessatorie]
                                        )
                                        props.onChangeField(
                                            CONSENT_FORM_FIELD_NAMES.clausoleVessatorieError,
                                            ''
                                        );
                                    }}
                                    errorText={props.form[CONSENT_FORM_FIELD_NAMES.clausoleVessatorieError]}
                                />
                            </InputBooleanWrapper>
                        </GrayDiv>

                        <GrayDiv>
                            <InfoIconContainer>
                                <InfoIcon onClick={() => {
                                    setPopupContent({ title: ConsentPageI18n.acceptFreeMarketTitle, content: <React.Fragment><FreeMarketText /></React.Fragment> });
                                    setIsInfoPopupOpen(true);
                                }} />
                            </InfoIconContainer>
                            <SectionTitle>{ConsentPageI18n.acceptFreeMarketTitle}</SectionTitle>
                                <InputBooleanWrapper>
                                    <InputBoolean
                                        label="Accetto"
                                        type="checkbox"
                                        isChecked={props.form[CONSENT_FORM_FIELD_NAMES.freeMarketOffer]}
                                        onChange={() => {
                                            props.onChangeField(
                                                CONSENT_FORM_FIELD_NAMES.freeMarketOffer,
                                                !props.form[CONSENT_FORM_FIELD_NAMES.freeMarketOffer]
                                            )
                                            props.onChangeField(
                                                CONSENT_FORM_FIELD_NAMES.freeMarketOfferError,
                                                ''
                                            );

                                        }}
                                        errorText={props.form[CONSENT_FORM_FIELD_NAMES.freeMarketOfferError]}
                                    />
                                </InputBooleanWrapper>
                        </GrayDiv>

                        <GrayDiv>
                            <SectionTitle>Consenso marketing</SectionTitle>
                            <SectionSubtitle>Consenso al trattamento per finalità di marketing</SectionSubtitle>

                            <MarketingContainer>
                                <MarketingTitle>PER POSTA</MarketingTitle>
                                <InputsBooleanWrapperMarketing>
                                    <InputBooleanWrapperMarketingRightMargin>
                                        <InputBoolean
                                            label="PRESTO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingMailAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingMailAccepted, true

                                                )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingMailNotAccepted, false
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingMailAcceptedError,
                                                    ''
                                                );
                                            }}
                                            errorText={props.form[CONSENT_FORM_FIELD_NAMES.marketingMailAcceptedError]}
                                        />
                                    </InputBooleanWrapperMarketingRightMargin>
                                    <InputBooleanWrapperMarketing>
                                        <InputBoolean
                                            label="NEGO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingMailNotAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                CONSENT_FORM_FIELD_NAMES.marketingMailNotAccepted, true
                                            )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingMailAccepted, false
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingMailAcceptedError,
                                                    ''
                                                );
                                            }}
                                            //errorText={props.form[CONSENT_FORM_FIELD_NAMES.marketingMailAcceptedError]}
                                        />
                                    </InputBooleanWrapperMarketing>
                                </InputsBooleanWrapperMarketing>
                            </MarketingContainer>

                            <MarketingContainer>
                                <MarketingTitle>PER TELEFONO</MarketingTitle>
                                <InputsBooleanWrapperMarketing>
                                    <InputBooleanWrapperMarketingRightMargin>
                                        <InputBoolean
                                            label="PRESTO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingPhoneAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingPhoneAccepted, true

                                                )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingPhoneNotAccepted, false
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingPhoneAcceptedError,
                                                    ''
                                                );
                                            }}
                                            errorText={props.form[CONSENT_FORM_FIELD_NAMES.marketingPhoneAcceptedError]}
                                        />
                                    </InputBooleanWrapperMarketingRightMargin>
                                    <InputBooleanWrapperMarketing>
                                        <InputBoolean
                                            label="NEGO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingPhoneNotAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingPhoneAccepted, false

                                                )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingPhoneNotAccepted, true
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingPhoneAcceptedError,
                                                    ''
                                                );
                                            }}
                                            //errorText={props.form[CONSENT_FORM_FIELD_NAMES.marketingPhoneAcceptedError]}
                                        />
                                    </InputBooleanWrapperMarketing>
                                </InputsBooleanWrapperMarketing>
                            </MarketingContainer>

                            <MarketingContainer>
                                <MarketingTitle>PER EMAIL</MarketingTitle>
                                <InputsBooleanWrapperMarketing>
                                    <InputBooleanWrapperMarketingRightMargin>
                                        <InputBoolean
                                            label="PRESTO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingEmailAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingEmailAccepted, true

                                                )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingEmailNotAccepted, false
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingEmailAcceptedError,
                                                    ''
                                                );
                                            }}
                                            errorText={props.form[CONSENT_FORM_FIELD_NAMES.marketingEmailAcceptedError]}
                                        />
                                    </InputBooleanWrapperMarketingRightMargin>
                                    <InputBooleanWrapperMarketing>
                                        <InputBoolean
                                            label="NEGO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingEmailNotAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingEmailAccepted, false

                                                )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingEmailNotAccepted, true
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingEmailAcceptedError,
                                                    ''
                                                );
                                            }}
                                        />
                                    </InputBooleanWrapperMarketing>
                                </InputsBooleanWrapperMarketing>
                            </MarketingContainer>

                            <MarketingContainer>
                                <MarketingTitle>CONSENSO AL TRATTAMENTO DATI PER FINALITÀ DI ELEBORAZIONE DEL PROFILO DI CONSUMATORE</MarketingTitle>
                                <InputsBooleanWrapperMarketing>
                                    <InputBooleanWrapperMarketingRightMargin>
                                        <InputBoolean
                                            label="PRESTO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingDataAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingDataAccepted, true

                                                )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingDataNotAccepted, false
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingDataAcceptedError,
                                                    ''
                                                );
                                            }}
                                            errorText={props.form[CONSENT_FORM_FIELD_NAMES.marketingDataAcceptedError]}
                                        />
                                    </InputBooleanWrapperMarketingRightMargin>
                                    <InputBooleanWrapperMarketing>
                                        <InputBoolean
                                            label="NEGO IL CONSENSO"
                                            type="radio"
                                            name="mail"
                                            isChecked={props.form[CONSENT_FORM_FIELD_NAMES.marketingDataNotAccepted]}
                                            onChange={() => {
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingDataAccepted, false

                                                )
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingDataNotAccepted, true
                                                );
                                                props.onChangeField(
                                                    CONSENT_FORM_FIELD_NAMES.marketingDataAcceptedError,
                                                    ''
                                                );
                                            }}
                                           //errorText={props.form[CONSENT_FORM_FIELD_NAMES.marketingDataAcceptedError]}
                                        />
                                    </InputBooleanWrapperMarketing>
                                </InputsBooleanWrapperMarketing>
                            </MarketingContainer>
                        </GrayDiv>
                        <SubmitButton
                            mainColor={THEME_COLORS.blueViolet}
                            type="submit"
                            value="PROSEGUI"
                            onClick={async e => {
                                //leggo il cookie di tc commander
                                let VivigasUIdCookie = document.cookie.replace(/(?:(?:^|.*;\s*)VivigasUId\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                                console.log('VivigasUId', VivigasUIdCookie)
                                e.preventDefault();
                                try {
                                    await props.submit();
                                    window.tC.event.confirmStep(this, {stepId: 'funnel_step5', user_id : `"${VivigasUIdCookie}"`})
                                    console.log('tCEvent-> confirmStep funnel_step5')
                                    props.history.push('/riepilogo')
                                } catch (error) {

                                }
                            }}
                            disabled={props.form[CONSENT_FORM_FIELD_NAMES.isSubmittingForm]}
                            errorText={props.form[CONSENT_FORM_FIELD_NAMES.errorFormSubmission]}
                            onClickSaveAndContinueLater={async e => {

                                e.preventDefault();
                                try {
                                    await props.submit(false);
                                    window.tC.event.dropOffConDatiSaveAndResume();
                                    console.log('tCEvent-> dropOffConDatiSaveAndResume funnel_step5')

                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                            successText={props.form[CONSENT_FORM_FIELD_NAMES.successText]}
                        />

                        <AccordionContainer>
                            <Accordion />
                        </AccordionContainer>
                    </div>

                    <div className=".d-xs-none .d-sm-none .d-md-none .d-lg-none col-xl-3">
                        <OfferBox {...props.offer} />
                    </div>
                </div>
            </div>
            <BottomSheet
                TriggerContent={
                    <BottomsheetTriggerContainer>
                        <div style={{ marginRight: '20px' }}>
                            <BottomsheetTriggerTitle>{props.offer.name}</BottomsheetTriggerTitle>
                            <BottomsheetTriggerSubTitle>VISUALIZZA I DETTAGLI</BottomsheetTriggerSubTitle>
                        </div>
                    </BottomsheetTriggerContainer>
                }
                HeaderContent={<BottomSheetHeaderText>CHIUDI I DETTAGLI</BottomSheetHeaderText>}
                backgroundColor="white"
                Content={<Offer {...props.offer} isMobile={true} />}
                maxExcludedScreenSize={MEDIA_QUERIES.desktop}
            />
        </React.Fragment>
    )
}